import React from 'react'
import { FaArrowRight } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import advisor from './images/advisor.jpg'

const Advisor = () => {
    return (
        <>

            <div className="">
                <div className="py-2">
                    <div className="relative md:px-10 after:w-[100%] md:after:w-[94%]  baner">
                        <img src={advisor} alt="value" className='md:h-[72vh] h-[45vh]' />
                        <div className=" absolute top-0 bottom-0 z-10 w-full md:w-[60%] md:left-[21%]  ">
                            <div className="md:mx-[4.5rem] mx-5 md:pt-16 ">
                                <div className="my-10"><h1 className='font-black text-[2.5rem]  tracking-wider text-white'>Advisory</h1>
                                    <h1 className='border-b-8 border-b-[#B5D1B3] w-[4rem]'></h1>
                                </div>
                                <div className="">
                                    <p className='tracking-wider leading-8 text-white text-[1rem] md:text-[1.5rem] font-bold'>Our experienced advisory professionals are some of Australia’s most skilled property and agribusiness professionals.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="text">
                    <div className="md:w-[57%] w-full  md:mx-[20rem] py-12">
                        <p className=' mx-4 md:mx-0 leading-7 tracking-wide'>We develop and help execute strategies throughout a property’s life cycle that support clients to achieve their objectives, whether it be for single assets or across complex portfolios.</p>
                        <p className='leading-7 md:mx-0 mx-4 py-10 tracking-wide'>As a tier-one firm we offer a full suite of services including: mortgage security; financial reporting; taxation valuations; pre-sale due diligence; leasing consultancy; insurance assessments; mergers and acquisitions; rental determinations; property rights advice; objections to statutory assessment; administration and insolvency; highest and best use analysis; expert witness and litigation; and, compulsory acquisition. We value collaboration within our team on every engagement and build relationships with our clients through ongoing dialogue, so we can deliver the very best results.</p>

                        <button className='border tracking-wider md:mx-0 mx-4 border-[#004a8b] text-[#004a8b] px-5 py-3 text-[13px] hover:border-[#B5D1B3] hover:bg-[#B5D1B3] hover:text-[black]'>CONTACT OUR TEAMS</button>
                    </div>

                    <div className="md:ml-[28rem]">
                        <div className="flex  pb-10 pt-[4rem]">
                            <h1 className='text-[10px]font-bold md:block hidden md:mx-[13rem] w-[6%] text-center justify-center border-b-2 border-[#004a8b] tracking-wider text-[#004a8b] '>
                                <span className='text-[10px] font-black'>ADVISORY</span>
                            </h1>
                            <button>
                                <Link to='/TranServices' className='text-[#004a8b] flex'><h1 className='my-1 md:mx-0 mx-3 text-[10px] font-black tracking-widest'>TRANSACTION</h1><FaArrowRight className='text-[#B5D1B3] font-black text-[1.3rem] w-[100%] mx-5' /></Link>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </>
    )
}

export default Advisor
